import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { EllipsisInMiddle } from '~/components/EllipsisInMiddle';
import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneCancelOrHideButton } from '~/components/FileStatusTrackingPane/TaskPaneCancelOrHideButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type GetInProgressMetadata, type LibraryRestorationTask } from '~/store/tasks/types';

export type RestoreLibraryPanelInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<LibraryRestorationTask>, 'title'>;
  onCancel: () => void;
};

export const RestoreLibraryPanelInProgressPanelItem = memo(
  ({ onCancel, metadata: { title } }: RestoreLibraryPanelInProgressPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();

    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle>{ui2026 ? 'Recovering library…' : 'Recovering library'}</FileStatusTitle>}
        subtitle={
          <FileStatusSubtitle className="flex text-nowrap">
            <span className="flex-none pr-1">Recovering library: </span>
            <EllipsisInMiddle className="font-bold" text={title || ''} />
          </FileStatusSubtitle>
        }
        buttons={<TaskPaneCancelOrHideButton onClick={onCancel} />}
      />
    );
  },
);

RestoreLibraryPanelInProgressPanelItem.displayName = 'RestoreLibraryPanelInProgressPanelItem';
